import { Container, Row } from "reactstrap";
import ActiveDisablePage from "./ActiveDisablePage";
import DefaultPagination from "./DefaultPagination";
import IconPagination from "./IconPagination";
import PaginationAlign from "./PaginationAlign";
import PaginationSize from "./PaginationSize";
import RoundedPagination from "./RoundedPagination";
import { Breadcrumbs } from "../../../AbstractElements";
import { BonusUi, PaginationTitle } from "../../../Constants/Constants";

const PaginationContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={PaginationTitle} parent={BonusUi} />
      <Container fluid>
        <Row>
          <DefaultPagination />
          <ActiveDisablePage />
          <IconPagination />
          <RoundedPagination />
          <PaginationAlign />
          <PaginationSize />
        </Row>
      </Container>
    </>
  );
};
export default PaginationContainer;
